/* eslint-disable */
import React, { useState } from "react";
import PropTypes from 'prop-types';
import styles from '../DealTransition/Dashboard/dealCard.module.scss';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid } from "@mui/material";

const formatDealValue = (value, title) => {
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }
  if (typeof value === "number") {
    return `${value}`;
  }

  if (typeof value === "string") {
    const items = value
      .split(",")
      .map(item => item.trim())
      .filter(Boolean);

    return title === "Emp experience (Years)"
      ? items.join(", ")
      : `${items.length}`;
  }

  if (Array.isArray(value)) {
    const items = value.filter(Boolean);
    return `${items.length}`;
  }

  return "";
};


const StaffCard = ({ data }) => {
  const { title, value, icon } = data;
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (title === "Skills required") {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  let skillsArray = [];

  if (Array.isArray(value)) {
    skillsArray = value.filter(Boolean);
  } else if (typeof value === "string") {
    skillsArray = value
      .split(",")
      .map((skill) => skill.trim())
      .filter(Boolean);
  }
  
  return (
    <>
      {/* Card Component */}
      <button className={styles["custom-deal-card"]} onClick={handleOpen}>
        <div className={styles["custom-deal-card-left"]}>
          <img src={icon} alt="icon" className={styles["custom-deal-card-icon"]} />
        </div>
        <div className={styles["custom-deal-card-right"]}>
          <div className={styles["custom-deal-card-title"]}>{title}</div>
          <div className={styles["custom-deal-card-value"]}>{formatDealValue(value, title)}</div>
        </div>
     </button>

      {/* Dialog Component */}
      <Dialog open={open} onClose={handleClose} sx={{ '& .MuiPaper-root': { borderRadius: '12px'}}}>
        {/* Dialog Title */}
        <DialogTitle className={styles["dialog-title"]}
          sx={{ boxShadow: '0px 2px 4px 0px #00000014'}}>Skills required</DialogTitle>

        {/* Dialog Content */}
        <DialogContent className={styles["dialog-content"]}>
          <Grid container>
            {skillsArray.map((skill) => (
              <Grid item xs={6} key={skill.id} className={styles["skill-item"]}>
                {skill}
              </Grid>
            ))}
          </Grid> 
        </DialogContent>

        {/* Dialog Actions (Footer) */}
        <DialogActions className={styles["dialog-actions"]}>
          <Button  onClick={handleClose} className={styles["close-button"]}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

StaffCard.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.any, 
    icon: PropTypes.string.isRequired,
  }).isRequired,
};

export default StaffCard;
